import React, { FC } from 'react'
import {
  MODAL_CONFIRM_DELETE_TITLE,
  MODAL_CONFIRM_DELETE_CONTENT,
  MODAL_CONFIRM_DELETE_OK,
} from '../../../../constants/event'
import { PrimaryConfirmModal } from '../../../molecules/ModalContainer/PrimaryDialogTemplate/PrimaryConfirmDialog'

interface ConfirmCancelModalProps {
  onSubmit: any
}

export const ConfirmDeleteModal: React.FC<ConfirmCancelModalProps> = props => {
  return (
    <PrimaryConfirmModal
      header={MODAL_CONFIRM_DELETE_TITLE}
      content={MODAL_CONFIRM_DELETE_CONTENT}
      onSubmit={props.onSubmit}
      label={MODAL_CONFIRM_DELETE_OK}
      skipButton={true}
    />
  )
}
